/**
 * CMS Service Configuration
 *
 * CDN base: https://cdn.mqcapital.co.uk/files/public/mqcapital
 *
 * CDN folder structure:
 *   /library/market-insights/weekly/          → weekly insight PDFs
 *   /library/market-insights/monthly/         → monthly report PDFs
 *   /library/strategy-descriptions/{strategy}/ → strategy description PDFs
 *   /strategies/{strategy}/factsheet/          → factsheet PDFs
 *   /strategies/{strategy}/weekly/             → weekly chart images (PNG/JPG/WEBP)
 *   /strategies/{strategy}/monthly/            → monthly chart images (PNG/JPG/WEBP)
 *
 * The CDN returns an HTML directory listing (not JSON).
 * cmsService.js parses the <a href> links automatically.
 *
 * File naming conventions (used by filename parser):
 *   Weekly charts:       {strategy}_{type}_YYYY-W{nn}.png|jpg|webp
 *                        e.g. strand-q_performance_2026-W09.png
 *   Monthly charts:      {strategy}_{type}_YYYY-MM.png|jpg|webp
 *                        e.g. strand-q_performance_2026-01.png
 *   Weekly insights:     market-insight_YYYY-W{nn}.pdf       e.g. market-insight_2026-W09.pdf
 *   Monthly reports:     monthly-report_YYYY-MM.pdf          e.g. monthly-report_2026-02.pdf
 *   Factsheets:          {strategy}_factsheet_YYYY-MM.pdf    e.g. strand-q_factsheet_2026-01.pdf
 *   Strategy descs:      {strategy}_description_YYYY-MM.pdf       e.g. strand-q_description_2026-01.pdf
 *   Desc covers:         {strategy}_description-cover_YYYY-MM.jpg (or .png/.webp)
 *                        e.g. strand-q_description-cover_2026-01.jpg
 *
 * Blog file naming (all files share the same base slug):
 *   /blogs/{slug}.json         → blog metadata + sections content
 *   /blogs/{slug}.png|jpg|jpeg → blog cover image (auto-resolved from slug)
 *   /blogs/{slug}.pdf          → blog PDF download (only when hasPdf: true in JSON)
 *   Slug examples: eur-not-currency, liquidity-risk, confusing-trend-regime
 */

const CMS_BASE_URL = 'https://cdn.mqcapital.co.uk/files/public/mqcapital';

const CMS_PATHS = {
  MARKET_INSIGHTS_WEEKLY: '/library/market-insights/weekly',
  MARKET_INSIGHTS_MONTHLY: '/library/market-insights/monthly',
  MARKET_INSIGHTS_WEEKLY_CONTENT:
    '/library/market-insights/weekly-insights-content.json',
  MARKET_INSIGHTS_WEEKLY_IMAGES: '/library/market-insights/weekly-images',
  STRATEGY_DESCRIPTIONS: strategy => `/strategies/${strategy}/description`,
  STRATEGY_FACTSHEETS: strategy => `/strategies/${strategy}/factsheet`,
  STRATEGY_CHARTS_WEEKLY: strategy => `/strategies/${strategy}/weekly`,
  STRATEGY_CHARTS_MONTHLY: strategy => `/strategies/${strategy}/monthly`,
  STRATEGY_PERFORMANCE: strategy => `/strategies/${strategy}/performance.json`,
  STRATEGY_BENCHMARKS: strategy => `/strategies/${strategy}/benchmarks.json`,
  BLOGS: '/blogs'
};

export { CMS_BASE_URL, CMS_PATHS };
